export default [
	'integration:webhook-subscription:create',
	'integration:webhook-subscription:read',
	'integration:webhook-subscription:search',
	'integration:webhook-subscription:update',
	'integration:webhook-subscription:delete',
] as const;
